/* eslint-disable import/no-anonymous-default-export */
import { Button, Form, Input, Select, Space, Table, Progress, Tooltip, notification } from "antd";
import { FilterValue } from "antd/lib/table/interface";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import DataFilter from "../../common/components/DataFilter";
import DataTable, { DataTableRef } from "../../common/components/DataTable";
import FiltroInfracciones, { FiltroInfraccionesRef } from "../../infracciones/components/FiltroInfracciones";
import { ActionResult, Query } from "../../common/hooks/useApi";
import useLotesRenombradoAPI, { LoteRenombrado } from "../hooks/useLotesRenombradoAPI";
import styled from "styled-components";
import useUsuariosAPI, { Usuario } from "../../usuarios/useUsuariosAPI";
import { UnidadProduccion } from "../../unidades-produccion/useUnidadesProduccionAPI";

const StyledForm = styled(Form)`
display: grid;
grid-template-columns: 1fr auto;
grid-gap: 1rem;
`;

export default () => {
    const api = useLotesRenombradoAPI();
    const refTable = useRef<DataTableRef>(null!);
    const filtroInfraccionesRef = useRef<FiltroInfraccionesRef>(null);
    const renombradoresApi = useUsuariosAPI();

    const [renombradoresResponse, setRenombradoresResponse] = useState<ActionResult<Usuario[]>>();
    const [loadingForm, setLoadingForm] = useState(false);
    const [total, setTotal] = useState<number>();
    const [nroLoteFilterForm] = Form.useForm();
    const [query, setQuery] = useState<Query>();
    const [unidadesProdSeleccionadas,setUnidadesProdSeleccionadas] = useState<any>([])
    const [unidadesProdNombres,setUnidadesProdNombres] = useState<any>([])

    const onSubmit = async (values: any) => {
        setLoadingForm(true);
        const response = await api.assignPending(values.RenombradorId, query,unidadesProdNombres);
        if (!response.error) {
            notification.success({ message: "Lote de renombrado asignado correctamente" });
        }
        else {
            notification.error({ message: "Error al asignar el lote de renombrado" });
            return;
        }
        await filtroInfraccionesRef.current?.loadTotal();
        await refTable.current.loadItems();
        
        setLoadingForm(false);
    };

    const generateFilters = (filters: Record<string, FilterValue | null>) => {

        return [
            filters?.NroLote != null ? `NroLote eq ${filters!.NroLote![0]}` : "",

        ];
    }

    useEffect(() => {
        renombradoresApi
            .list({ $filter: ["Role/Nombre eq 'Renombrador'"], $orderby: ["Apellido desc"] })
            .then(setRenombradoresResponse);
    }, [])

    useEffect(() => {
        if (unidadesProdSeleccionadas.length === 0) {
            return;
        }
        const unidadesProduccionNombres = unidadesProdSeleccionadas.map((unidad: UnidadProduccion) => unidad.Nombre);
        setUnidadesProdNombres(unidadesProduccionNombres)
      }, [unidadesProdSeleccionadas]);

    return (
        <>
            <Space size={"large"} direction="vertical">

                <div>
                    <StyledForm onFinish={onSubmit}>
                        <Form.Item
                            rules={[
                                { required: true, message: "Campo requerido" }
                            ]}
                            name="RenombradorId"
                            required
                            label="Renombrador">
                            <Select
                                showSearch
                                optionFilterProp="children"
                                loading={!renombradoresResponse}
                                allowClear>
                                {renombradoresResponse?.data?.value.map(usuario => <Select.Option value={usuario.Id} key={usuario.Id}>{usuario.Apellido} {usuario.Nombre}</Select.Option>)}
                            </Select>
                        </Form.Item>
                        <Button disabled={!total || total == 0} loading={loadingForm} htmlType="submit" type="primary">Asignar</Button>
                    </StyledForm>

                    <FiltroInfracciones
                        count={api.getPendingCount}
                        ref={filtroInfraccionesRef}
                        onChange={(query) => {
                            setQuery(query);
                        }}
                        onChangeCount={(count)=>{
                            setTotal(count);
                        }}
                        onChangeLoading={(loading)=>{
                            setLoadingForm(loading);
                        }}
                        onChangeUnidadesProd={(unid) => setUnidadesProdSeleccionadas(unid)}
                    />
                </div>

                <DataTable<LoteRenombrado, LoteRenombrado>
                    list={(query) => api.list({
                        ...query,
                        ...{ 
                            $expand:["RenombradorAsignado"]
                        }
                    })}
                    delete={async (id) => {
                        const result = await api.delete(id);
                        await filtroInfraccionesRef.current?.loadTotal();
                        return result;
                    }}
                    deleteMultipleAction
                    defaultSortOrder={"NroLote desc"}
                    selectionType='checkbox'
                    title={"Lotes de renombrado"}
                    generateFilters={generateFilters}
                    deleteItemAction
                    deleteItemActionConfirmMessage={(item) => `¿Eliminar lote ${item.NroLote}?`}
                    defaultPageSize={5}
                    ref={refTable}

                >

                    <Table.Column<LoteRenombrado>
                        width={`20%`}
                        title="Fecha"
                        dataIndex={"FechaHora"}
                        sorter
                        render={(value, record, index) => moment(value).format("DD/MM/YYYY HH:mm:ss")}
                        sortDirections={["ascend", "descend", "ascend"]}

                    />

                    <Table.Column<LoteRenombrado>
                        width={`25%`}
                        title="Nro. de lote"
                        dataIndex={"NroLote"}
                        sorter
                        defaultSortOrder={'descend'}
                        sortDirections={["ascend", "descend", "ascend"]}
                        filterDropdown={(props) => {
                            return (
                                <DataFilter filterDropdownProps={props} form={nroLoteFilterForm} >
                                    <Form.Item name={"NroLote"} style={{ marginBottom: 10 }}>
                                        <Input placeholder='Nro. de lote...' />
                                    </Form.Item>
                                </DataFilter>
                            );
                        }
                        }

                    />

                    <Table.Column<LoteRenombrado>
                        width={`20%`}
                        title="Cantidad"
                        dataIndex={"CantidadInfracciones"}
                        sorter
                        sortDirections={["ascend", "descend", "ascend"]}

                    />

                    <Table.Column<LoteRenombrado>
                        width={`30%`}
                        title="Progreso"
                        sortDirections={["ascend", "descend", "ascend"]}
                        render={(value,record,index) => {

                            const cantidadEfectivas = record.CantidadInfraccionesEfectivas;
                            const cantidadIlegibles = record.CantidadInfraccionesIlegibles;

                            const porcentajeIlegibles = cantidadIlegibles * 100 / record.CantidadInfracciones;
                            const porcentajeEfectivas = cantidadEfectivas * 100 / record.CantidadInfracciones;
                            const cantidadPendientes = record.CantidadInfracciones - cantidadEfectivas - cantidadIlegibles;
                            let porcentajePrincipal = porcentajeIlegibles + porcentajeEfectivas;

                            return (
                                <Tooltip title={`${cantidadEfectivas} ${cantidadEfectivas > 1 ? "Efectivas" : "Efectiva"} (${porcentajeEfectivas.toFixed(2)}%) / ${cantidadIlegibles} ${cantidadIlegibles > 1 ? "Ilegibles" : "Ilegible"} (${porcentajeIlegibles.toFixed(2)}%) / ${cantidadPendientes} Pendientes `}>
                                  <Progress
                                    percent={parseFloat(porcentajePrincipal.toFixed(2))}
                                    strokeColor={'green'}
                                    success={{
                                      strokeColor: 'red',
                                      percent: parseFloat(porcentajeIlegibles.toFixed(2)),
                                    }}
                                  />
                                </Tooltip>
                          )
                        }}
                    />

                    <Table.Column<LoteRenombrado>
                        width={`20%`}
                        title="Unidad de producción"
                        render={(val, record) => (
                            <div style={{ textAlign: 'center' }}>
                              {record.UnidadesProdNombre
                                ? record.UnidadesProdNombre
                                : "-"}
                            </div>
                          )}
                    />

                    <Table.Column<LoteRenombrado>
                        width={`20%`}
                        title="Renombrador asignado"
                        render={(value, record, index) =>`${record.RenombradorAsignado.Nombre} ${record.RenombradorAsignado.Apellido}`}
                    />
                </DataTable>
            </Space>


        </>
    );

};